import { createFileRoute } from '@tanstack/react-router';
import { buildSignInRedirect } from '../lib/portal-redirect';

/**
 * Phase 14a-2 — fallback splash shown for the (rare) moment between
 * the route guard catching a 401 and the browser actually navigating
 * to the portal sign-in URL.
 *
 * In practice the guard's `window.location.href = …` fires first; this
 * route only renders if JS is disabled or the redirect fails. The
 * manual button gives the operator a path forward.
 */
export const Route = createFileRoute('/sign-in-required')({
  component: SignInRequiredPage,
});

function SignInRequiredPage() {
  let target = '';
  try {
    target = buildSignInRedirect('/');
  } catch {
    // VITE_PORTAL_URL unset — fall back to a placeholder; the operator
    // (or developer) will get a clearer error when they click through.
    target = '/sign-in';
  }
  return (
    <div className="mx-auto max-w-md px-6 py-20 text-center">
      <h1 className="font-heading text-3xl text-forest md:text-4xl">Sign-in required</h1>
      <p className="mt-3 text-sm text-ink-muted">
        You need to sign in to access the admin tools.
      </p>
      <a
        href={target}
        className="mt-6 inline-block rounded-md bg-forest px-4 py-2 text-cream"
      >
        Continue to sign in
      </a>
    </div>
  );
}
